module.exports = __webpack_public_path__ + "media/1x1/lv-f3c1274d.svg";